const videoIframes: NodeListOf<HTMLIFrameElement> = document.querySelectorAll(
  '[id^="gallery-video-"]',
);

videoIframes.forEach((iframe) => {
  document.addEventListener("dialog.onopen", () => {
    if (iframe.dataset.src) {
      iframe.setAttribute("src", iframe.dataset?.src + "?enablejsapi=1");
      iframe.removeAttribute("data-src");
    }
  });

  document.addEventListener("dialog.onclose", () => {
    iframe.contentWindow?.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*",
    );
  });
});
